module.exports = __webpack_public_path__ + "media/images/top/common/img_solution01-7b9569d5556e4cf310f50f01878ffa14.png";